var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"baseForm"},[_c('div',{staticClass:"formDom"},[_c('Form',{ref:"grantForm",attrs:{"dataSource":_vm.getBaseForm,"id":"grantForm"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }